<template>
  <div class="login_box">
    <div class="cover_box"> 
      <div class="logo">
        <img src="../../assets/logo.png" alt="" srcset="" style="width: 1.5rem; height: 1.5rem">
        <p>云透管家</p>
      </div>

      <div class="rectangle"></div>
      <div class="annulus"></div>
      <div class="dot"></div>
      <div class="circle"></div>
      <div class="rectangle2"></div>

      <div class="squares-group">
        <i
          class="geo-element square square-blue animate-fade-in-left-rotated-blue"
          style="animation-delay: 0.2s;transform: translateX(0px) rotate(-10deg);"
        ></i>
        <i
          class="geo-element square square-pink animate-fade-in-left-rotated-pink"
          style="animation-delay: 0.4s;transform: translateX(0px) rotate(10deg);"
        ></i>
        <i
          class="geo-element square square-purple animate-fade-in-left-no-rotation"
          style="animation-delay: 0.6s"
        ></i>
      </div>
    </div>
    <div class="form_box">
      <login v-if="$store.state.auth.isLoginPages"/>
      <register v-else/>
    </div>
  </div>
</template>

<script>
// 引入Vue2核心
// import Vue from 'vue'
// 导入图片和子组件
import logoImage from '../../assets/logo.png'
import register from './modules/register.vue'
import login from './modules/login.vue'

export default {
  name: 'Login',
  components: {
    register,
    login
  },
  data() {
    return {
      logoImage: logoImage
    }
  }
}
</script>

<style scoped>
/* 基础容器样式 - 展开SCSS嵌套 */
.login_box {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

/* 左侧封面容器 */
.login_box .cover_box {
  width: 60%;
  height: 100%;
  background-color: #E8F2FF;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Logo样式 */
.login_box .cover_box .logo {
  margin-top: -0.3rem;
  height: 100%;
  display: flex;
  position: absolute;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.5rem;
}

.login_box .cover_box .logo p {
  margin-top: 0.2rem;
  letter-spacing: 0.1rem;
}

/* 圆形装饰 */
.login_box .cover_box .circle {
  width: 2.5rem;
  height: 2.5rem;
  /* 替换SCSS的rgb(from)为原生CSS的rgba */
  background-color: rgba(64, 158, 255, 0.1);
  border-radius: 50%;
  position: relative;
  top: -40%;
  left: 35%;
}

/* 矩形装饰1 */
.login_box .cover_box .rectangle {
  width: 1.2rem;
  height: 1.2rem;
  background-color: rgba(64, 158, 255, 0.15);
  transform: translateX(0px) rotate(-10deg);
  position: relative;
  top: -5%;
  left: -1rem;
  border-radius: 5px;
}

/* 矩形装饰2 */
.login_box .cover_box .rectangle2 {
  width: 1.2rem;
  height: 1.2rem;
  background-color: rgba(64, 158, 255, 0.15);
  transform: translateX(0px) rotate(10deg);
  position: relative;
  top: 30%;
  left: 2rem;
  border-radius: 5px;
}

/* 小点装饰 */
.login_box .cover_box .dot {
  width: 0.2rem;
  height: 0.2rem;
  background-color: rgba(64, 158, 255, 0.45);
  border-radius: 50%;
  position: relative;
  top: -20%;
  left: -1rem;
}

/* 圆环装饰 */
.login_box .cover_box .annulus {
  width: 0.5rem;
  height: 0.5rem;
  border: 5px solid rgba(64, 158, 255, 0.25);
  border-radius: 50%;
  position: relative;
  top: -40%;
  left: -1rem;
}

/* 叠加方块组容器 */
.login_box .cover_box .squares-group {
  position: relative;
  bottom: -2rem;
  left: -6rem;
  width: 1.5rem;
  height: 1.5rem;
  pointer-events: none;
}

/* 通用方块样式 */
.login_box .cover_box .squares-group .square {
  position: relative;
  display: block;
  border-radius: 0.1rem;
  box-shadow: 0 8px 24px rgba(64, 87, 167, 0.12);
}

/* 蓝色方块 - 替换SCSS的&为原生CSS组合选择器 */
.login_box .cover_box .squares-group .square.square-blue {
  top: 0.8rem;
  left: 0.5rem;
  z-index: 2;
  width: 0.7rem;
  height: 0.7rem;
  background-color: rgba(64, 158, 255, 0.3);
}

/* 粉色方块 */
.login_box .cover_box .squares-group .square.square-pink {
  top: 0.5rem;
  left: 0.8rem;
  z-index: 1;
  width: 1rem;
  height: 1rem;
  background-color: rgba(64, 158, 255, 0.15);
}

/* 紫色方块 */
.login_box .cover_box .squares-group .square.square-purple {
  top: 0.2rem;
  left: 1.4rem;
  z-index: 3;
  width: 0.5rem;
  height: 0.5rem;
  background-color: rgba(64, 158, 255, 0.45);
}

/* 装饰线条伪元素 */
.login_box .cover_box .squares-group::after {
  position: relative;
  top: 86px;
  left: 72px;
  width: 80px;
  height: 1px;
  content: '';
  background: linear-gradient(90deg, rgba(64, 158, 255, 0.6), transparent);
  opacity: 0;
  transform: rotate(50deg);
  animation: lineGrow 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
  animation-delay: 1.2s;
}

/* 右侧表单容器 */
.login_box .form_box {
  width: 40%;
  height: 100%;
  background-color: #ffffff;
  z-index: 10;
}

/* 补全动画关键帧（原SCSS中可能省略的部分） */
@keyframes lineGrow {
  from {
    width: 0;
    opacity: 0;
  }
  to {
    width: 80px;
    opacity: 1;
  }
}

/* 如需使用fade-in动画，可补充以下关键帧（根据实际需求调整） */
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-fade-in-left-rotated-blue,
.animate-fade-in-left-rotated-pink,
.animate-fade-in-left-no-rotation {
  animation: fadeInLeft 0.8s ease forwards;
}
</style>